import { Box, Button, Paper } from '@material-ui/core'

import React from 'react'
import styled from 'styled-components'

const StyledPaperContainer = styled(Paper)`
  height: 100%;
  margin: 10px 0px;
  padding: 20px;
`

const StyledButtonContainer = styled.div`
  margin: 0px 5px 0px 5px;
`

const StyledButton = (props: any) => (
  <StyledButtonContainer>
    <Button {...props} />
  </StyledButtonContainer>
)

const CategoryFormHandlerBar = ({
  saveHandler,
  createHandler,
  newForm
}: {
  saveHandler: (...args: any) => any
  createHandler: (...args: any) => any
  newForm: boolean
}) => {
  return (
    <StyledPaperContainer>
      <Box display="flex" justifyContent="flex-end">
        {newForm ? (
          <StyledButton
            variant="contained"
            color="primary"
            onClick={createHandler}
          >
            Create
          </StyledButton>
        ) : (
          <StyledButton
            variant="outlined"
            color="default"
            onClick={saveHandler}
          >
            Save
          </StyledButton>
        )}
      </Box>
    </StyledPaperContainer>
  )
}

export default CategoryFormHandlerBar
